import { render, staticRenderFns } from "./BaseCheckbox.vue?vue&type=template&id=4484e730"
import script from "./BaseCheckbox.vue?vue&type=script&lang=js"
export * from "./BaseCheckbox.vue?vue&type=script&lang=js"
import style0 from "./BaseCheckbox.vue?vue&type=style&index=0&id=4484e730&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports